import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成

import { updateBaseMenu, getMenuList, addBaseMenu, deleteBaseMenu, getBaseMenuById } from "@/api/menu";
import infoList from "@/components/mixins/infoList";
import icon from "@/view/superAdmin/menu/icon";
export default {
  name: "Menus",
  mixins: [infoList],
  data: function data() {
    return {
      showTable: false,
      checkFlag: false,
      listApi: getMenuList,
      dialogFormVisible: false,
      dialogTitle: this.$t('common.add'),
      menuOption: [{
        ID: "0",
        title: this.$t('menu.root_menu')
      }],
      form: {
        ID: 0,
        path: "",
        name: "",
        hidden: "",
        parentId: "",
        component: "",
        meta: {
          title: "",
          icon: "",
          defaultMenu: false,
          keepAlive: false
        },
        parameters: []
      },
      rules: {
        path: [{
          required: true,
          message: this.$t('menu.name_required'),
          trigger: "blur"
        }],
        component: [{
          required: true,
          message: this.$t('menu.file_path_required'),
          trigger: "blur"
        }],
        "meta.title": [{
          required: true,
          message: this.$t('menu.label_required'),
          trigger: "blur"
        }]
      },
      isEdit: false,
      test: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.showTable = true;
    });
  },
  activated: function activated() {
    var _this2 = this;
    this.showTable = false;
    this.$nextTick(function () {
      _this2.showTable = true;
    });
  },
  components: {
    icon: icon
  },
  methods: {
    addParameter: function addParameter(form) {
      if (!form.parameters) {
        form.parameters = [];
      }
      form.parameters.push({
        type: "query",
        key: "",
        value: ""
      });
    },
    deleteParameter: function deleteParameter(parameters, index) {
      parameters.splice(index, 1);
    },
    changeName: function changeName() {
      this.form.path = this.form.name;
    },
    setOptions: function setOptions() {
      this.menuOption = [{
        ID: "0",
        title: this.$t('menu.root_menu')
      }];
      //console.log("menu tableData:"+this.tableData);
      this.setMenuOptions(this.tableData, this.menuOption, false);
      //console.log("menu:"+this.menuOption);
    },
    setMenuOptions: function setMenuOptions(menuData, optionsData, disabled) {
      var _this3 = this;
      menuData && menuData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            title: item.meta.title,
            ID: String(item.ID),
            disabled: disabled || item.ID == _this3.form.ID,
            children: []
          };
          _this3.setMenuOptions(item.children, option.children, disabled || item.ID == _this3.form.ID);
          optionsData.push(option);
        } else {
          var _option = {
            title: item.meta.title,
            ID: String(item.ID),
            disabled: disabled || item.ID == _this3.form.ID
          };
          optionsData.push(_option);
        }
      });
    },
    handleClose: function handleClose(done) {
      this.initForm();
      done();
    },
    // 懒加载子菜单
    load: function load(tree, treeNode, resolve) {
      resolve([{
        id: 31,
        date: "2016-05-01",
        name: "王小虎",
        address: "上海市普陀区金沙江路 1519 弄"
      }, {
        id: 32,
        date: "2016-05-01",
        name: "王小虎",
        address: "上海市普陀区金沙江路 1519 弄"
      }]);
    },
    // 删除菜单
    deleteMenu: function deleteMenu(ID) {
      var _this4 = this;
      this.$confirm(this.$t('common.delete_warning'), "", {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return deleteBaseMenu({
                ID: ID
              });
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: _this4.$t("common.success")
                });
                _this4.getTableData();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function () {
        _this4.$message({
          type: "info",
          message: _this4.$t('common.cancel')
        });
      });
    },
    // 初始化弹窗内表格方法
    initForm: function initForm() {
      this.checkFlag = false;
      this.$refs.menuForm.resetFields();
      this.form = {
        ID: 0,
        path: "",
        name: "",
        hidden: "",
        parentId: "",
        component: "",
        meta: {
          title: "",
          icon: "",
          defaultMenu: false,
          keepAlive: ""
        }
      };
    },
    // 关闭弹窗
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
    },
    // 添加menu
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs.menuForm.validate(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                  var res;
                  return regeneratorRuntime.wrap(function (_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 5;
                          break;
                        }
                        if (!_this5.isEdit) {
                          _context2.next = 2;
                          break;
                        }
                        _context2.next = 1;
                        return updateBaseMenu(_this5.form);
                      case 1:
                        res = _context2.sent;
                        _context2.next = 4;
                        break;
                      case 2:
                        _context2.next = 3;
                        return addBaseMenu(_this5.form);
                      case 3:
                        res = _context2.sent;
                      case 4:
                        if (res.code == 0) {
                          _this5.$message({
                            type: "success",
                            message: _this5.$t('common.success')
                          });
                          _this5.getTableData();
                        }
                        _this5.initForm();
                        _this5.dialogFormVisible = false;
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }(),
    // 添加菜单方法，id为 0则为添加根菜单
    addMenu: function addMenu(id) {
      this.dialogTitle = this.$t('common.add');
      this.form.parentId = String(id);
      this.isEdit = false;
      this.setOptions();
      this.dialogFormVisible = true;
    },
    // 修改菜单方法
    editMenu: function () {
      var _editMenu = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.dialogTitle = this.$t('common.edit');
              _context4.next = 1;
              return getBaseMenuById({
                id: id
              });
            case 1:
              res = _context4.sent;
              this.form = res.data.menu;
              this.isEdit = true;
              this.setOptions();
              this.dialogFormVisible = true;
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function editMenu(_x2) {
        return _editMenu.apply(this, arguments);
      }
      return editMenu;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            this.pageSize = 999;
            _context5.next = 1;
            return this.getTableData();
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};